import React from 'react';
import { Modal } from "react-bootstrap"

function StaffInfoModal({ showModal, hideModal }) {
  return (
    <Modal
      show={showModal}
      onHide={hideModal}
      centered
      size="lg"
    >
      <Modal.Header className="modal__header">
        <span>About Roles</span>
        <span
          className="modal__header__btn"
          onClick={hideModal}
          aria-label="Exit"
        >
          X
        </span>
      </Modal.Header>

      <Modal.Body>
        <ul>
          <li className="mb-3">
            <strong>Administrator: </strong>
            Can configure all parts of the environment (user accounts, demographic templates, measures, programs, services, etc.) as well as do any case management necessary for any client / program / measure.                 </li>
          <li className="mb-3">
            <strong>Manager: </strong>
            Can assign staff and clients to itself, view staff and clients that they are assigned, and edit both assigned clients and staffs.
          </li>
          <li className="mb-3">
            <strong>Staff with Assigned Clients: </strong>
            Can perform case management tasks for clients to whom they have access.

            Staff in this role can have their clients set directly (with the "Assigned Clients" type) or by all clients in a program (with the "Clients in Assigned Programs" type).
          </li>
          <li className="mb-3">
            <strong>Staff with All Clients: </strong>
            Can do everything a staff can do, but with all clients in the system.
          </li>
          <li className="mb-3">
            <strong>Analytics User: </strong>
            Only has access to the main dashboard and the analytics tab.
          </li>
        </ul>
      </Modal.Body>
    </Modal>
  )
}

export default StaffInfoModal;
